<template>
  <v-container v-if="isUsersDataLoaded" fluid class=" justify-start align-start " style="height: 100%" >
    <v-row>
      <v-col cols="12">
  <v-data-table
    :headers="headers"
    :items="users"
    :items-per-page="10"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Пользователи</v-toolbar-title>
        <v-spacer/>
      </v-toolbar>
    </template>
  </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'OwnerGoods',
  data(){
    return{
      isUsersDataLoaded : true,
      headers: [
        {
          text: 'id',
          align: 'left',
          sortable: false,
          value: 'id',
        },
        { text: 'Имя', value: 'name' },
        { text: 'Должность', value: 'position' },
      ],
      users: [
        {
          id: 3243234,
          name: 'Иван',
          position: 'admin',
        },
        {
          id: 45545,
          name: 'Кирилл',
          position: 'user',
        },
      ],
    }
  },
}
</script>

<style scoped>

</style>
